import { initBurgerMenu } from './header/burger.js';
import { initExperiencePro } from './home/experience/index.js';
import { initLeadForm } from './forms/lead-form.js';

console.log('BurakTech main.js loaded');

document.addEventListener('DOMContentLoaded', () => {
    initBurgerMenu();
    initExperiencePro();
    initLeadForm();
});
